import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { Gender } from '@/shared/types/billing';

/**
 * Practice-wide gender value-set. Returns Gender[] where each item is
 * `{id, name}` and `id` is a server-managed GUID, NOT a slug like "male".
 *
 * Endpoint: `GET /api/Master/Gender` — mirrors Flutter
 * `common_data_source_impl.dart:164 fetchGenderList`.
 *
 * Sending the local string ids ("male"/"female") to a service-create
 * payload returns 400: "Error converting value to System.Guid" — must
 * use the GUIDs returned by this hook.
 */
const MASTER_BASE = '/api/Master';

export function useGenderList() {
  return useQuery({
    queryKey: ['master', 'genders'],
    queryFn: ({ signal }) =>
      get<Gender[]>(`${MASTER_BASE}/Gender`, { signal }),
    // Genders rarely change; cache for the whole session.
    staleTime: Infinity,
  });
}
